// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import exclamation from './exclamation.svg';
import { Separator } from '../../atoms';

type Props = {|
  children: Node,
|};

export function WarningDisplay({ children }: Props): Node {
  return (
    <WarningWrapper>
      <IconWrapper>
        <Icon />
      </IconWrapper>
      <Separator direction="horizontal" size="1.5em" />
      <TextWrapper>
        {children}
      </TextWrapper>
    </WarningWrapper>
  );
}

const WarningWrapper = styled.div`
  background: #fdf9e7;
  border: 1px solid #f1c40f;
  display: flex;
  border-radius: 0.35em;
  padding: 1em;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const TextWrapper = styled.div`
  color: #856831;
  font-size: 0.9em;
`;

const Icon = styled.i`
  background: #f1c40f;
  border-radius: 50%;
  padding: 1em;
  position: relative;

  ::after {
    content: '';
    margin: 0.5em;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background-color: transparent;
    background-image: url(${exclamation});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
`;
